import { apiClient } from './apiClient';

export interface BrandingSettings {
  appName?: string;
  appSubtitle?: string;
  logoUrl?: string;
  logoCompactUrl?: string;
  faviconUrl?: string;
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  fontFamily?: string;
  supportEmail?: string;
  legalUrl?: string;
  privacyUrl?: string;
  maxDemoPerMonth?: number;
  maxDemoPerMoth?: number;
  demoDays?: number;
  modules?: BrandingModules;
}

export interface BrandingModules {
  categories?: boolean;
  tvChannels?: boolean;
  liveTvCountriesEnabled?: boolean;
  radioCountriesEnabled?: boolean;
  tvGuide?: boolean;
  radioStations?: boolean;
  documentaries?: boolean;
  movies?: boolean;
  concerts?: boolean;
  tvShows?: boolean;
  sports?: boolean;
  iptvProviders?: boolean;
  flussonicServers?: boolean;
  channelAutomations?: boolean;
  channelScraping?: boolean;
  audienceManagementEnabled?: boolean;
  fullAddressEnabled?: boolean;
  ads?: boolean;
  reports?: boolean;
  accounting?: boolean;
}

export const brandingService = {
  async getBranding(): Promise<BrandingSettings | null> {
    try {
      const response = await apiClient.get<BrandingSettings | null>('/settings/branding');
      if (!response || typeof response !== 'object') {
        return null;
      }
      if (response.modules) response.modules.audienceManagementEnabled ??= response.modules.fullAddressEnabled;
      return response;
    } catch {
      return null;
    }
  },
};
